import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    innerItemContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginLeft: 20,
        zIndex: 1
    },
    logoNameContainer: {
        flexDirection: 'row'
    },
    itemName: {
        flexGrow: 0,
        flexShrink: 2,
        textAlign: 'left',
        marginLeft: 20,
        marginRight: Theme.BU * 2 + 10,
        fontSize: 20
    },
    itemDivider: {
        marginVertical: 5
    },
    favoriteIcon: {
        position: 'absolute',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        right: 10,
        top: 0,
        height: '100%'
    }
};

export default StyleSheet.create(baseStyles);
